import * as yup from 'yup'

// Types
import { cloneDeep } from 'lodash'
import { IHorseData } from './horse.interface'

// Models
import { ModelBaseModel } from '../model-base/model-base.model'

export class HorseModel extends ModelBaseModel<IHorseData> {
  public id?: IHorseData['id']
  public horseId?: IHorseData['horseId']
  public horseOwnerId: IHorseData['horseOwnerId']
  public horseOwnerName: IHorseData['horseOwnerName']
  public horseOwnerPicture: IHorseData['horseOwnerPicture']
  public horseName: IHorseData['horseName']
  public horseNameNGram: IHorseData['horseNameNGram']
  public horseBreed: IHorseData['horseBreed']
  public horseBreeder: IHorseData['horseBreeder']
  public horseProfilePicture: IHorseData['horseProfilePicture']
  public horseHeight: IHorseData['horseHeight']
  public horseDob: IHorseData['horseDob']
  public horseAgeVerified?: IHorseData['horseAgeVerified']
  public horseGender: IHorseData['horseGender']
  public horseDiscipline: IHorseData['horseDiscipline']
  public horseColor: IHorseData['horseColor']
  public horseZone: IHorseData['horseZone']
  public horseMarking: IHorseData['horseMarking']
  public horseCountry: IHorseData['horseCountry']
  public horseMicrochipNumber?: IHorseData['horseMicrochipNumber']
  public horseMicrochipExpiration?: IHorseData['horseMicrochipExpiration']

  public horsePassportNumber?: IHorseData['horsePassportNumber']
  public horsePassportExpiration?: IHorseData['horsePassportExpiration']

  public horseDNACaseNumber?: IHorseData['horseDNACaseNumber']
  public horseDNACaseExpiration?: IHorseData['horseDNACaseExpiration']

  public horseTeamMembers: IHorseData['horseTeamMembers']
  public horseTeamMembers_: IHorseData['horseTeamMembers_']
  public horseStatus: IHorseData['horseStatus']
  public horseFeiStatus: IHorseData['horseFeiStatus']

  // English discipline numbers
  public horseFeiNumber: IHorseData['horseFeiNumber']
  public horseFeiExpiration: IHorseData['horseFeiExpiration']
  public horseFeiImage: IHorseData['horseFeiImage']

  public horseUseaNumber?: IHorseData['horseUseaNumber']
  public horseUseaExpiration?: IHorseData['horseUseaExpiration']
  public horseUseaImage?: IHorseData['horseUseaImage']

  public horseUsefNumber: IHorseData['horseUsefNumber']
  public horseUsefExpiration: IHorseData['horseUsefExpiration']
  public horseUsefImage: IHorseData['horseUsefImage']

  public horseUsdfNumber?: IHorseData['horseUsdfNumber']
  public horseUsdfExpiration?: IHorseData['horseUsdfExpiration']
  public horseUsdfImage?: IHorseData['horseUsdfImage']

  public horseUshjaNumber?: IHorseData['horseUshjaNumber']
  public horseUshjaExpiration?: IHorseData['horseUshjaExpiration']
  public horseUshjaImage?: IHorseData['horseUshjaImage']

  public horseAhhsNumber?: IHorseData['horseAhhsNumber']
  public horseAhhsExpiration?: IHorseData['horseAhhsExpiration']
  public horseAhhsImage?: IHorseData['horseAhhsImage']

  public horseAmhaNumber?: IHorseData['horseAmhaNumber']
  public horseAmhaExpiration?: IHorseData['horseAmhaExpiration']
  public horseAmhaImage?: IHorseData['horseAmhaImage']

  public horseArhpaNumber?: IHorseData['horseArhpaNumber']
  public horseArhpaExpiration?: IHorseData['horseArhpaExpiration']
  public horseArhpaImage?: IHorseData['horseArhpaImage']

  public horseAshaNumber?: IHorseData['horseAshaNumber']
  public horseAshaExpiration?: IHorseData['horseAshaExpiration']
  public horseAshaImage?: IHorseData['horseAshaImage']

  public horseUphaNumber?: IHorseData['horseUphaNumber']
  public horseUphaExpiration?: IHorseData['horseUphaExpiration']
  public horseUphaImage?: IHorseData['horseUphaImage']

  public horseWdaaNumber?: IHorseData['horseWdaaNumber']
  public horseWdaaExpiration?: IHorseData['horseWdaaExpiration']
  public horseWdaaImage?: IHorseData['horseWdaaImage']

  public horseAcpsNumber?: IHorseData['horseAcpsNumber']
  public horseAcpsExpiration?: IHorseData['horseAcpsExpiration']
  public horseAcpsImage?: IHorseData['horseAcpsImage']

  public horseAhaNumber?: IHorseData['horseAhaNumber']
  public horseAhaExpiration?: IHorseData['horseAhaExpiration']
  public horseAhaImage?: IHorseData['horseAhaImage']

  public horseEvusaNumber?: IHorseData['horseEvusaNumber']
  public horseEvusaExpiration?: IHorseData['horseEvusaExpiration']
  public horseEvusaImage?: IHorseData['horseEvusaImage']

  public horseIalhaNumber?: IHorseData['horseIalhaNumber']
  public horseIalhaExpiration?: IHorseData['horseIalhaExpiration']
  public horseIalhaImage?: IHorseData['horseIalhaImage']

  public horseIfshaNumber?: IHorseData['horseIfshaNumber']
  public horseIfshaExpiration?: IHorseData['horseIfshaExpiration']
  public horseIfshaImage?: IHorseData['horseIfshaImage']

  public horseNshrNumber?: IHorseData['horseNshrNumber']
  public horseNshrExpiration?: IHorseData['horseNshrExpiration']
  public horseNshrImage?: IHorseData['horseNshrImage']

  public horsePfhaNumber?: IHorseData['horsePfhaNumber']
  public horsePfhaExpiration?: IHorseData['horsePfhaExpiration']
  public horsePfhaImage?: IHorseData['horsePfhaImage']

  public horseWpcsaNumber?: IHorseData['horseWpcsaNumber']
  public horseWpcsaExpiration?: IHorseData['horseWpcsaExpiration']
  public horseWpcsaImage?: IHorseData['horseWpcsaImage']

  public horseUstaNumber?: IHorseData['horseUstaNumber']
  public horseUstaExpiration?: IHorseData['horseUstaExpiration']
  public horseUstaImage?: IHorseData['horseUstaImage']

  public horseEcNumber?: IHorseData['horseEcNumber']
  public horseEcExpiration?: IHorseData['horseEcExpiration']
  public horseEcImage?: IHorseData['horseEcImage']

  // Western discipline numbers
  public horseArhaNumber?: IHorseData['horseArhaNumber']
  public horseArhaExpiration?: IHorseData['horseArhaExpiration']
  public horseArhaImage?: IHorseData['horseArhaImage']

  public horseAphaNumber?: IHorseData['horseAphaNumber']
  public horseAphaExpiration?: IHorseData['horseAphaExpiration']
  public horseAphaImage?: IHorseData['horseAphaImage']

  public horseAqhaNumber?: IHorseData['horseAqhaNumber']
  public horseAqhaExpiration?: IHorseData['horseAqhaExpiration']
  public horseAqhaImage?: IHorseData['horseAqhaImage']

  public horseBbrNumber?: IHorseData['horseBbrNumber']
  public horseBbrExpiration?: IHorseData['horseBbrExpiration']
  public horseBbrImage?: IHorseData['horseBbrImage']

  public horseIbraNumber?: IHorseData['horseIbraNumber']
  public horseIbraExpiration?: IHorseData['horseIbraExpiration']
  public horseIbraImage?: IHorseData['horseIbraImage']

  public horseNbhaNumber?: IHorseData['horseNbhaNumber']
  public horseNbhaExpiration?: IHorseData['horseNbhaExpiration']
  public horseNbhaImage?: IHorseData['horseNbhaImage']

  public horseNchaNumber?: IHorseData['horseNchaNumber']
  public horseNchaExpiration?: IHorseData['horseNchaExpiration']
  public horseNchaImage?: IHorseData['horseNchaImage']

  public horseNrchaNumber?: IHorseData['horseNrchaNumber']
  public horseNrchaExpiration?: IHorseData['horseNrchaExpiration']
  public horseNrchaImage?: IHorseData['horseNrchaImage']

  public horseNrhaNumber?: IHorseData['horseNrhaNumber']
  public horseNrhaExpiration?: IHorseData['horseNrhaExpiration']
  public horseNrhaImage?: IHorseData['horseNrhaImage']

  public horseNsbaNumber?: IHorseData['horseNsbaNumber']
  public horseNsbaExpiration?: IHorseData['horseNsbaExpiration']
  public horseNsbaImage?: IHorseData['horseNsbaImage']

  // Rodeo discipline numbers
  public horseApraNumber?: IHorseData['horseApraNumber']
  public horseApraExpiration?: IHorseData['horseApraExpiration']
  public horseApraImage?: IHorseData['horseApraImage']

  public horseIpraNumber?: IHorseData['horseIpraNumber']
  public horseIpraExpiration?: IHorseData['horseIpraExpiration']
  public horseIpraImage?: IHorseData['horseIpraImage']

  public horsePbrNumber?: IHorseData['horsePbrNumber']
  public horsePbrExpiration?: IHorseData['horsePbrExpiration']
  public horsePbrImage?: IHorseData['horsePbrImage']

  public horsePrcaNumber?: IHorseData['horsePrcaNumber']
  public horsePrcaExpiration?: IHorseData['horsePrcaExpiration']
  public horsePrcaImage?: IHorseData['horsePrcaImage']

  public horseWpraNumber?: IHorseData['horseWpraNumber']
  public horseWpraExpiration?: IHorseData['horseWpraExpiration']
  public horseWpraImage?: IHorseData['horseWpraImage']

  // College discipline numbers
  public horseIhsaNumber?: IHorseData['horseIhsaNumber']
  public horseIhsaExpiration?: IHorseData['horseIhsaExpiration']
  public horseIhsaImage?: IHorseData['horseIhsaImage']

  public horseNceaNumber?: IHorseData['horseNceaNumber']
  public horseNceaExpiration?: IHorseData['horseNceaExpiration']
  public horseNceaImage?: IHorseData['horseNceaImage']

  public horseNhsraNumber?: IHorseData['horseNhsraNumber']
  public horseNhsraExpiration?: IHorseData['horseNhsraExpiration']
  public horseNhsraImage?: IHorseData['horseNhsraImage']

  public horseNiraNumber?: IHorseData['horseNiraNumber']
  public horseNiraExpiration?: IHorseData['horseNiraExpiration']
  public horseNiraImage?: IHorseData['horseNiraImage']

  public horseNlbrNumber?: IHorseData['horseNlbrNumber']
  public horseNlbrExpiration?: IHorseData['horseNlbrExpiration']
  public horseNlbrImage?: IHorseData['horseNlbrImage']

  public horseOtherNumber: IHorseData['horseOtherNumber']
  public horsesOther?: IHorseData['horsesOther']

  public horseGeldingStatus: IHorseData['horseGeldingStatus']
  public horseGeldingDate: IHorseData['horseGeldingDate']

  public created: IHorseData['created']
  public modified: IHorseData['modified']

  public constructor(obj?: IHorseData) {
    super()
    this.id = obj?.id || ''
    this.horseId = obj?.horseId || ''
    this.horseOwnerId = obj?.horseOwnerId || null
    this.horseOwnerName = obj?.horseOwnerName || null
    this.horseOwnerPicture = obj?.horseOwnerPicture || null
    this.horseStatus = obj?.horseStatus || ''
    this.horseProfilePicture = obj?.horseProfilePicture || ''

    this.horseName = obj?.horseName || ''
    this.horseTeamMembers_ = obj?.horseTeamMembers_ ?? []
    this.horseBreed = obj?.horseBreed || []
    this.horseBreeder = obj?.horseBreeder || ''
    this.horseHeight = obj?.horseHeight || ''
    this.horseDob = obj?.horseDob
      ? this.utcTimestamp({
          key: 'horseDob',
          value: obj?.horseDob,
        })
      : ''
    this.horseAgeVerified = obj?.horseAgeVerified || ''
    this.horseGender = obj?.horseGender || ''
    this.horseDiscipline = obj?.horseDiscipline || ''
    this.horseZone = obj?.horseZone || ''
    this.horseColor = obj?.horseColor || ''
    this.horseMarking = obj?.horseMarking ?? null
    this.horseCountry = obj?.horseCountry || ''
    this.horseTeamMembers = obj?.horseTeamMembers || []
    this.horseNameNGram = obj?.horseNameNGram ?? []

    this.horseMicrochipNumber = obj?.horseMicrochipNumber || ''
    this.horseMicrochipExpiration = obj?.horseMicrochipExpiration
      ? this.utcTimestamp({
          key: 'horseMicrochipExpiration',
          value: obj?.horseMicrochipExpiration,
        })
      : ''
    this.horsePassportNumber = obj?.horsePassportNumber || ''
    this.horsePassportExpiration = obj?.horsePassportExpiration
      ? this.utcTimestamp({
          key: 'horsePassportExpiration',
          value: obj?.horsePassportExpiration,
        })
      : ''
    this.horseDNACaseNumber = obj?.horseDNACaseNumber || ''
    this.horseDNACaseExpiration = obj?.horseDNACaseExpiration
      ? this.utcTimestamp({
          key: 'horseDNACaseExpiration',
          value: obj?.horseDNACaseExpiration,
        })
      : ''

    // English discipline numbers
    this.horseFeiNumber = obj?.horseFeiNumber || ''
    this.horseFeiExpiration = obj?.horseFeiExpiration
      ? this.utcTimestamp({
          key: 'horseFeiExpiration',
          value: obj?.horseFeiExpiration,
        })
      : ''
    this.horseFeiImage = obj?.horseFeiImage || ''
    this.horseFeiStatus = obj?.horseFeiStatus ? obj?.horseFeiStatus : ''

    this.horseUsefNumber = obj?.horseUsefNumber || ''
    this.horseUsefExpiration = obj?.horseUsefExpiration
      ? this.utcTimestamp({
          key: 'horseUsefExpiration',
          value: obj?.horseUsefExpiration,
        })
      : ''
    this.horseUsefImage = obj?.horseUsefImage || ''

    this.horseUsdfNumber = obj?.horseUsdfNumber || ''
    this.horseUsdfExpiration = obj?.horseUsdfExpiration
      ? this.utcTimestamp({
          key: 'horseUsdfExpiration',
          value: obj?.horseUsdfExpiration,
        })
      : ''
    this.horseUsdfImage = obj?.horseUsdfImage || ''

    this.horseUseaNumber = obj?.horseUseaNumber || ''
    this.horseUseaExpiration = obj?.horseUseaExpiration
      ? this.utcTimestamp({
          key: 'horseUseaExpiration',
          value: obj?.horseUseaExpiration,
        })
      : ''
    this.horseUseaImage = obj?.horseUseaImage || ''

    this.horseUshjaNumber = obj?.horseUshjaNumber || ''
    this.horseUshjaExpiration = obj?.horseUshjaExpiration
      ? this.utcTimestamp({
          key: 'horseUshjaExpiration',
          value: obj?.horseUshjaExpiration,
        })
      : ''
    this.horseUshjaImage = obj?.horseUshjaImage || ''

    this.horseAhhsNumber = obj?.horseAhhsNumber || ''
    this.horseAhhsExpiration = obj?.horseAhhsExpiration
      ? this.utcTimestamp({
          key: 'horseAhhsExpiration',
          value: obj?.horseAhhsExpiration,
        })
      : ''
    this.horseAhhsImage = obj?.horseAhhsImage || ''

    this.horseAmhaNumber = obj?.horseAmhaNumber || ''
    this.horseAmhaExpiration = obj?.horseAmhaExpiration
      ? this.utcTimestamp({
          key: 'horseAmhaExpiration',
          value: obj?.horseAmhaExpiration,
        })
      : ''
    this.horseAmhaImage = obj?.horseAmhaImage || ''

    this.horseArhpaNumber = obj?.horseArhpaNumber || ''
    this.horseArhpaExpiration = obj?.horseArhpaExpiration
      ? this.utcTimestamp({
          key: 'horseArhpaExpiration',
          value: obj?.horseArhpaExpiration,
        })
      : ''
    this.horseArhpaImage = obj?.horseArhpaImage || ''

    this.horseAshaNumber = obj?.horseAshaNumber || ''
    this.horseAshaExpiration = obj?.horseAshaExpiration
      ? this.utcTimestamp({
          key: 'horseAshaExpiration',
          value: obj?.horseAshaExpiration,
        })
      : ''
    this.horseAshaImage = obj?.horseAshaImage || ''

    this.horseUphaNumber = obj?.horseUphaNumber || ''
    this.horseUphaExpiration = obj?.horseUphaExpiration
      ? this.utcTimestamp({
          key: 'horseUphaExpiration',
          value: obj?.horseUphaExpiration,
        })
      : ''
    this.horseUphaImage = obj?.horseUphaImage || ''

    this.horseWdaaNumber = obj?.horseWdaaNumber || ''
    this.horseWdaaExpiration = obj?.horseWdaaExpiration
      ? this.utcTimestamp({
          key: 'horseWdaaExpiration',
          value: obj?.horseWdaaExpiration,
        })
      : ''
    this.horseWdaaImage = obj?.horseWdaaImage || ''

    this.horseAcpsNumber = obj?.horseAcpsNumber || ''
    this.horseAcpsExpiration = obj?.horseAcpsExpiration
      ? this.utcTimestamp({
          key: 'horseAcpsExpiration',
          value: obj?.horseAcpsExpiration,
        })
      : ''
    this.horseAcpsImage = obj?.horseAcpsImage || ''

    this.horseAhaNumber = obj?.horseAhaNumber || ''
    this.horseAhaExpiration = obj?.horseAhaExpiration
      ? this.utcTimestamp({
          key: 'horseAhaExpiration',
          value: obj?.horseAhaExpiration,
        })
      : ''
    this.horseAhaImage = obj?.horseAhaImage || ''

    this.horseEvusaNumber = obj?.horseEvusaNumber || ''
    this.horseEvusaExpiration = obj?.horseEvusaExpiration
      ? this.utcTimestamp({
          key: 'horseEvusaExpiration',
          value: obj?.horseEvusaExpiration,
        })
      : ''
    this.horseEvusaImage = obj?.horseEvusaImage || ''

    this.horseIalhaNumber = obj?.horseIalhaNumber || ''
    this.horseIalhaExpiration = obj?.horseIalhaExpiration
      ? this.utcTimestamp({
          key: 'horseIalhaExpiration',
          value: obj?.horseIalhaExpiration,
        })
      : ''
    this.horseIalhaImage = obj?.horseIalhaImage || ''

    this.horseIfshaNumber = obj?.horseIfshaNumber || ''
    this.horseIfshaExpiration = obj?.horseIfshaExpiration
      ? this.utcTimestamp({
          key: 'horseIfshaExpiration',
          value: obj?.horseIfshaExpiration,
        })
      : ''
    this.horseIfshaImage = obj?.horseIfshaImage || ''

    this.horseNshrNumber = obj?.horseNshrNumber || ''
    this.horseNshrExpiration = obj?.horseNshrExpiration
      ? this.utcTimestamp({
          key: 'horseNshrExpiration',
          value: obj?.horseNshrExpiration,
        })
      : ''
    this.horseNshrImage = obj?.horseNshrImage || ''

    this.horsePfhaNumber = obj?.horsePfhaNumber || ''
    this.horsePfhaExpiration = obj?.horsePfhaExpiration
      ? this.utcTimestamp({
          key: 'horsePfhaExpiration',
          value: obj?.horsePfhaExpiration,
        })
      : ''
    this.horsePfhaImage = obj?.horsePfhaImage || ''

    this.horseWpcsaNumber = obj?.horseWpcsaNumber || ''
    this.horseWpcsaExpiration = obj?.horseWpcsaExpiration
      ? this.utcTimestamp({
          key: 'horseWpcsaExpiration',
          value: obj?.horseWpcsaExpiration,
        })
      : ''
    this.horseWpcsaImage = obj?.horseWpcsaImage || ''

    this.horseUstaNumber = obj?.horseUstaNumber || ''
    this.horseUstaExpiration = obj?.horseUstaExpiration
      ? this.utcTimestamp({
          key: 'horseUstaExpiration',
          value: obj?.horseUstaExpiration,
        })
      : ''
    this.horseUstaImage = obj?.horseUstaImage || ''

    this.horseEcNumber = obj?.horseEcNumber || ''
    this.horseEcExpiration = obj?.horseEcExpiration
      ? this.utcTimestamp({
          key: 'horseEcExpiration',
          value: obj?.horseEcExpiration,
        })
      : ''
    this.horseEcImage = obj?.horseEcImage || ''

    // Western discipline numbers
    this.horseArhaNumber = obj?.horseArhaNumber || ''
    this.horseArhaExpiration = obj?.horseArhaExpiration
      ? this.utcTimestamp({
          key: 'horseArhaExpiration',
          value: obj?.horseArhaExpiration,
        })
      : ''
    this.horseArhaImage = obj?.horseArhaImage || ''

    this.horseAphaNumber = obj?.horseAphaNumber || ''
    this.horseAphaExpiration = obj?.horseAphaExpiration
      ? this.utcTimestamp({
          key: 'horseAphaExpiration',
          value: obj?.horseAphaExpiration,
        })
      : ''
    this.horseAphaImage = obj?.horseAphaImage || ''

    this.horseAqhaNumber = obj?.horseAqhaNumber || ''
    this.horseAqhaExpiration = obj?.horseAqhaExpiration
      ? this.utcTimestamp({
          key: 'horseAqhaExpiration',
          value: obj?.horseAqhaExpiration,
        })
      : ''
    this.horseAqhaImage = obj?.horseAqhaImage || ''

    this.horseBbrNumber = obj?.horseBbrNumber || ''
    this.horseBbrExpiration = obj?.horseBbrExpiration
      ? this.utcTimestamp({
          key: 'horseBbrExpiration',
          value: obj?.horseBbrExpiration,
        })
      : ''
    this.horseBbrImage = obj?.horseBbrImage || ''

    this.horseIbraNumber = obj?.horseIbraNumber || ''
    this.horseIbraExpiration = obj?.horseIbraExpiration
      ? this.utcTimestamp({
          key: 'horseIbraExpiration',
          value: obj?.horseIbraExpiration,
        })
      : ''
    this.horseIbraImage = obj?.horseIbraImage || ''

    this.horseNbhaNumber = obj?.horseNbhaNumber || ''
    this.horseNbhaExpiration = obj?.horseNbhaExpiration
      ? this.utcTimestamp({
          key: 'horseNbhaExpiration',
          value: obj?.horseNbhaExpiration,
        })
      : ''
    this.horseNbhaImage = obj?.horseNbhaImage || ''

    this.horseNchaNumber = obj?.horseNchaNumber || ''
    this.horseNchaExpiration = obj?.horseNchaExpiration
      ? this.utcTimestamp({
          key: 'horseNchaExpiration',
          value: obj?.horseNchaExpiration,
        })
      : ''
    this.horseNchaImage = obj?.horseNchaImage || ''

    this.horseNrchaNumber = obj?.horseNrchaNumber || ''
    this.horseNrchaExpiration = obj?.horseNrchaExpiration
      ? this.utcTimestamp({
          key: 'horseNrchaExpiration',
          value: obj?.horseNrchaExpiration,
        })
      : ''
    this.horseNrchaImage = obj?.horseNrchaImage || ''

    this.horseNrhaNumber = obj?.horseNrhaNumber || ''
    this.horseNrhaExpiration = obj?.horseNrhaExpiration
      ? this.utcTimestamp({
          key: 'horseNrhaExpiration',
          value: obj?.horseNrhaExpiration,
        })
      : ''
    this.horseNrhaImage = obj?.horseNrhaImage || ''

    this.horseNsbaNumber = obj?.horseNsbaNumber || ''
    this.horseNsbaExpiration = obj?.horseNsbaExpiration
      ? this.utcTimestamp({
          key: 'horseNsbaExpiration',
          value: obj?.horseNsbaExpiration,
        })
      : ''
    this.horseNsbaImage = obj?.horseNsbaImage || ''

    // Rodeo discipline numbers
    this.horseApraNumber = obj?.horseApraNumber || ''
    this.horseApraExpiration = obj?.horseApraExpiration
      ? this.utcTimestamp({
          key: 'horseApraExpiration',
          value: obj?.horseApraExpiration,
        })
      : ''
    this.horseApraImage = obj?.horseApraImage || ''

    this.horseIpraNumber = obj?.horseIpraNumber || ''
    this.horseIpraExpiration = obj?.horseIpraExpiration
      ? this.utcTimestamp({
          key: 'horseIpraExpiration',
          value: obj?.horseIpraExpiration,
        })
      : ''
    this.horseIpraImage = obj?.horseIpraImage || ''

    this.horsePbrNumber = obj?.horsePbrNumber || ''
    this.horsePbrExpiration = obj?.horsePbrExpiration
      ? this.utcTimestamp({
          key: 'horsePbrExpiration',
          value: obj?.horsePbrExpiration,
        })
      : ''
    this.horsePbrImage = obj?.horsePbrImage || ''

    this.horsePrcaNumber = obj?.horsePrcaNumber || ''
    this.horsePrcaExpiration = obj?.horsePrcaExpiration
      ? this.utcTimestamp({
          key: 'horsePrcaExpiration',
          value: obj?.horsePrcaExpiration,
        })
      : ''
    this.horsePrcaImage = obj?.horsePrcaImage || ''

    this.horseWpraNumber = obj?.horseWpraNumber || ''
    this.horseWpraExpiration = obj?.horseWpraExpiration
      ? this.utcTimestamp({
          key: 'horseWpraExpiration',
          value: obj?.horseWpraExpiration,
        })
      : ''
    this.horseWpraImage = obj?.horseWpraImage || ''

    // College discipline numbers
    this.horseIhsaNumber = obj?.horseIhsaNumber || ''
    this.horseIhsaExpiration = obj?.horseIhsaExpiration
      ? this.utcTimestamp({
          key: 'horseIhsaExpiration',
          value: obj?.horseIhsaExpiration,
        })
      : ''
    this.horseIhsaImage = obj?.horseIhsaImage || ''

    this.horseNceaNumber = obj?.horseNceaNumber || ''
    this.horseNceaExpiration = obj?.horseNceaExpiration
      ? this.utcTimestamp({
          key: 'horseNceaExpiration',
          value: obj?.horseNceaExpiration,
        })
      : ''
    this.horseNceaImage = obj?.horseNceaImage || ''

    this.horseNhsraNumber = obj?.horseNhsraNumber || ''
    this.horseNhsraExpiration = obj?.horseNhsraExpiration
      ? this.utcTimestamp({
          key: 'horseNhsraExpiration',
          value: obj?.horseNhsraExpiration,
        })
      : ''
    this.horseNhsraImage = obj?.horseNhsraImage || ''

    this.horseNiraNumber = obj?.horseNiraNumber || ''
    this.horseNiraExpiration = obj?.horseNiraExpiration
      ? this.utcTimestamp({
          key: 'horseNiraExpiration',
          value: obj?.horseNiraExpiration,
        })
      : ''
    this.horseNiraImage = obj?.horseNiraImage || ''

    this.horseNlbrNumber = obj?.horseNlbrNumber || ''
    this.horseNlbrExpiration = obj?.horseNlbrExpiration
      ? this.utcTimestamp({
          key: 'horseNlbrExpiration',
          value: obj?.horseNlbrExpiration,
        })
      : ''
    this.horseNlbrImage = obj?.horseNlbrImage || ''

    // Other discipline numbers
    this.horseOtherNumber = obj?.horseOtherNumber || ''
    this.horsesOther = obj?.horsesOther || []

    this.horseGeldingStatus = obj?.horseGeldingStatus || ''
    this.horseGeldingDate = obj?.horseGeldingDate
      ? this.utcTimestamp({
          key: 'horseGeldingDate',
          value: obj?.horseGeldingDate,
        })
      : ''

    this.created = obj?.created
      ? this.utcTimestamp({
          key: 'created',
          value: obj?.created,
        })
      : new Date().toString()

    this.modified = obj?.modified
      ? this.utcTimestamp({
          key: 'modified',
          value: obj?.modified,
        })
      : new Date().toString()

    this._calculateEventNameNGrams()
  }

  private _calculateEventNameNGrams() {
    let reg = new RegExp(/\s+/, 'g')
    let horsenospace = this.horseName?.replace(reg, '')
    const words = horsenospace?.split(' ')
    const lowercase_words = words?.map((word) => word.toLowerCase())

    let ngram_words = new Set<string>()

    lowercase_words?.forEach((word) => {
      let word_iterator = cloneDeep(word)

      while (word_iterator.length > 0) {
        ngram_words.add(cloneDeep(word_iterator))
        word_iterator = word_iterator.slice(0, -1)
      }
    })

    if (this.horseNameNGram && this.horseNameNGram.length > 0) {
      this.horseNameNGram = []
    }

    ngram_words.forEach((value) => {
      if (this.horseNameNGram) this.horseNameNGram.push(value)
    })
  }

  static fromFirestoreDoc(doc: any) {
    return new HorseModel({
      ...doc.data(),
      id: doc?.id,
    })
  }

  static paperworkValidationSchema() {
    return yup.object().shape({
      measurementCard: yup.array().of(yup.object().shape({})),
    })
  }
}
